import { createElement } from 'react'
import { get } from 'lodash'
import ErrorMessage from 'components/ErrorMessage'
import getDisplayName from 'lib/get-display-name'

const defaultOptions = {
  path: 'dataExists',
  title: 'Not found',
  primaryButton: undefined,
  messaging: null
}

// withNotFoundHandler wraps a component and renders a 404 if its required
// data was not found
export default (opts = {}) => WrappedComponent => {
  const withNotFoundHandler = props => {
    const providedOptions = typeof opts === 'function' ? opts(props) : opts
    const finalOptions = { ...defaultOptions, ...providedOptions }
    const wasResourceFound = get(props, finalOptions.path)

    if (wasResourceFound) {
      return createElement(WrappedComponent, props)
    }

    return createElement(ErrorMessage, { ...finalOptions, ...props })
  }

  withNotFoundHandler.displayName = `withNotFoundHandler(${getDisplayName(
    WrappedComponent
  )})`

  return withNotFoundHandler
}
